module.exports = __webpack_public_path__ + "static/media/sandwich.0b61d92c.svg";